import { ReactNode } from "react";
import { IHierarchySWOT } from "./HierarchySWOT/interface";

interface IModalSWOT extends Omit<IHierarchySWOT,"register"|"setValue">{
    onClose?: Function | undefined;
    subtitle?: string;
    title?: string;
    onSubmit?: (data:any) => void;
    footer?:{
        showSaveButton?: boolean;
        saveButtonText?: string;
        cancelButtonText?: string;
        buttonLoadingText?: string;
        customModalFooter?: ReactNode;
    };
    nodeContent?: ReactNode;
    initialData?:Array<number>;
}

export enum SWOTHierarchyLevel {
    DIMENSION  = 1,
    SECTION = 2,
    ITEM = 3
}

export default IModalSWOT;
